export const MOBILE_APP_STORE_URLS = Object.freeze({
  IOS: 'https://apps.apple.com/us/app/securspace-gate-check/id1642950907',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.envasetechnologies.securspace.gate.app&hl=en_US',
});
